export const ConsoleEventLogTypes = {
  SET_CONSOLEEVENTLOGS: 'SET_CONSOLEEVENTLOGS'
};
